import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { AttachmentModalData } from '../../../Attachment/attachment.modal.model';
import { CommentModalData } from '../../../Comments/comments.service';

export interface ICellRendererParamsForFilingBatchListGridAction extends ICellRendererParams {
    canEdit: boolean;
    viewDetails: (params: ICellRendererParamsForFilingBatchListGridAction) => void;
    delete: (params: ICellRendererParamsForFilingBatchListGridAction) => void;
    canDelete: (params: ICellRendererParamsForFilingBatchListGridAction) => boolean;
}

@Component({
    selector: 'filing-batch-list-grid-action-cell',
    template:
        `
        @if (filingBatch) {
          <button type="button"
            helpTooltip
            helpContentId="app.view"
            position="bottom"
            class="ace-btn btn-primary has-icon grid-action-button"
            (click)="onViewDetailsClicked()">
            <i class="fa fa-pencil"></i>
          </button>
        }
        @if (filingBatch) {
          <span class="icon-indicator">
            <i class="fa fa-fw"></i>
          </span>
        }
        @if (filingBatch && filingBatch.hasComments) {
          <span class="icon-indicator">
            <i class="fa fa-commenting"></i>
          </span>
        }
        @if (filingBatch && !filingBatch.hasComments) {
          <span class="icon-indicator">
            <i class="fa fa-fw"></i>
          </span>
        }
        @if (filingBatch && filingBatch.hasAttachments) {
          <span class="icon-indicator">
            <i class="fa fa-files-o"></i>
          </span>
        }
        @if (filingBatch) {
          <entity-comments
            [(hasComments)]="filingBatch.hasComments"
            buttonClass="ace-btn btn-primary has-icon grid-action-button"
            [modalData]="commentModalData"
            helpTooltip
            helpContentId="app.comments"
            position="bottom">
          </entity-comments>
        }
        @if (filingBatch) {
          <entity-attachments [(hasAttachments)]="filingBatch.hasAttachments"
            buttonClass="ace-btn btn-primary has-icon grid-action-button"
            [modalData]="attachmentModalData"
            helpTooltip
            helpContentId="app.attachments"
            position="bottom">
          </entity-attachments>
        }
        @if (filingBatch && params.canDelete(params)) {
          <button type="button"
            class="ace-btn has-icon btn-primary btn-danger grid-action-button"
            (click)="onDeleteClicked()"
            helpTooltip
            helpContentId="app.delete"
            position="bottom">
            <i class="fa fa-trash"></i>
          </button>
        }
        `,
    standalone: false
})
export class FilingBatchListGridActionCellRendererComponent implements ICellRendererAngularComp {
    params: ICellRendererParamsForFilingBatchListGridAction;
    filingBatch: Compliance.FilingBatchModel;
    attachmentModalData: AttachmentModalData;
    commentModalData: CommentModalData;

    agInit(params: ICellRendererParamsForFilingBatchListGridAction): void {
        this.params = params;
        this.filingBatch = params.data as Compliance.FilingBatchModel;

        if (!this.filingBatch) {
            return;
        }
        this.attachmentModalData = {
            entityType: 'FilingBatch', //todo: make this a constant generated typescript value
            entityName: this.filingBatch.description,
            year: this.filingBatch.taxYear,
            disableYears: true,
            singleYear: true,
            entityData: {
                typeId: Core.EntityTypes.FilingBatch,
                id: this.filingBatch.filingBatchId,
                name: this.filingBatch.description
            },
            readOnly: !this.params.canEdit
        } as AttachmentModalData;

        this.commentModalData = {
            entityID: this.filingBatch.filingBatchId,
            entityTypeID: Core.EntityTypes.FilingBatch,
            entityName: this.filingBatch.description,
            parcelAcctNum: null,
            canEdit: this.params.canEdit,
            description: null,
            parcelID: null,
            year: this.filingBatch.taxYear ? this.filingBatch.taxYear.toString() : null
        } as CommentModalData;
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }

    onViewDetailsClicked(): void {
        this.params.viewDetails(this.params);
    }

    onDeleteClicked(): void {
        this.params.delete(this.params);
    }
}
